import facebookGray from "@img/logos/social/dark/facebook.svg";
import instagramGray from "@img/logos/social/dark/instagram.svg";
import spotifyGray from "@img/logos/social/dark/spotify.svg";
import tiktokGray from "@img/logos/social/dark/tiktok.svg";
import youtubeGray from "@img/logos/social/dark/youtube.svg";
import facebook from "@img/logos/social/facebook.svg";
import instagram from "@img/logos/social/instagram.svg";
import spotify from "@img/logos/social/spotify.svg";
import tiktok from "@img/logos/social/tiktok.svg";
import youtube from "@img/logos/social/youtube.svg";
import React from "react";
import type { ReactNode } from "react";

interface Props {
	orientation?: "vertical" | "horizontal";
	justifycontent?: "start" | "end" | "center" | "between" | "around";
	colorscheme?: "light" | "dark";
}

interface SocialIconData {
	name: string;
	lightImg: string;
	darkImg: string;
	url: string;
}

const socialIconData: SocialIconData[] = [
	{ name: "Facebook", lightImg: facebook, darkImg: facebookGray, url: "https://www.facebook.com/Bankmonitor/" },
	{ name: "TikTok", lightImg: tiktok, darkImg: tiktokGray, url: "https://www.tiktok.com/@bankmonitor" },
	{ name: "YouTube", lightImg: youtube, darkImg: youtubeGray, url: "https://www.youtube.com/c/bankmonitorhu" },
	{
		name: "Spotify",
		lightImg: spotify,
		darkImg: spotifyGray,
		url: "https://open.spotify.com/show/2INKMPOZktVANZ7zltnp77",
	},
	{
		name: "Instagram",
		lightImg: instagram,
		darkImg: instagramGray,
		url: "https://www.instagram.com/bankmonitorhu/",
	},
];

/**
 * @Shortcode
 *
 * @title "Social ikonok"
 * @shortcode "social_icons"
 * @type "widget"
 * @propsList "[{"justifycontent":"between"},{"orientation":"vertical"},{"colorscheme":"grayscale"}]"
 * @lazyHydrate "whenIdle"
 */
export class SocialIcons extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { orientation = "horizontal", justifycontent = "end", colorscheme = "light" } = this.props;
		const dark = colorscheme === "dark";
		const vertical = orientation === "vertical";
		const iconClasses = vertical ? "m-2" : "mx-3";
		const containerClasses = vertical
			? "social-icons-container d-flex flex-column"
			: `social-icons-container d-flex w-100 justify-content-${justifycontent} py-2 align-items-center`;

		return (
			<div className={containerClasses}>
				{socialIconData.map((icon: SocialIconData) => (
					<a
						href={icon.url}
						className={iconClasses}
						key={`icon-${icon.name}${dark ? "-dark" : ""}`}
						title={icon.name}
						target="_blank"
						rel="noreferrer"
					>
						<img
							src={dark ? icon.darkImg : icon.lightImg}
							alt={`icon-${icon.name}${dark ? "-dark" : ""}`}
						/>
					</a>
				))}
			</div>
		);
	}
}

export default SocialIcons;
